import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../components/widgets';
import FileDropzone from '../../../components/molecules/FileDropzone';
import Icon, { IconVariants } from '../../../components/foundations/Icon';
import FormatTable from './FormatTable';
import { IMPORT_MODAL_PREFIX as PREFIX } from './consts';
import css from './ImportModal.css';

const UploadView = ({
    translate,
    formatRows,
    helpLink,
    file,
    uploading,
    onFileChange,
    onClearFile,
    onSubmit,
    onClose,
}) => {
    const [formatOpen, setFormatOpen] = useState(true);

    return (
        <>
            <div className={css.body}>
                <div className={css.warningBanner}>
                    <Icon name="info-triangle" variant={IconVariants.WARNING} interactive={false} />
                    <div>
                        <p className={css.bannerTitle}>{translate(`${PREFIX}.WARNING_TITLE`)}</p>
                        <ul className={css.warningList}>
                            <li>{translate(`${PREFIX}.WARNING_BLANK_DATE`)}</li>
                            <li>{translate(`${PREFIX}.WARNING_SKIP_VALUE`)}</li>
                            <li>{translate(`${PREFIX}.WARNING_EXACT_VALUES`)}</li>
                            {helpLink && (
                                <li>
                                    <a href={helpLink} target="_blank" rel="noopener noreferrer">
                                        {translate(`${PREFIX}.HELP_LINK_TEXT`)}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                <div className={css.formatSection}>
                    <button type="button" className={css.formatToggle} onClick={() => setFormatOpen(open => !open)}>
                        <span>
                            <Icon name="table" interactive={false} /> {translate(`${PREFIX}.EXPECTED_FORMAT`)}
                        </span>
                        <Icon name={formatOpen ? 'chevron-up' : 'chevron-down'} interactive={false} />
                    </button>
                    {formatOpen && <FormatTable formatRows={formatRows} translate={translate} />}
                </div>

                <FileDropzone
                    promptText={`${PREFIX}.DROPZONE`}
                    value={file}
                    clearable
                    disabled={uploading}
                    acceptableTypes={['.csv']}
                    onChange={selected => (selected ? onFileChange(selected) : onClearFile())}
                />
            </div>
            <div className={css.footer}>
                <Button type="secondary" disabled={uploading} onClick={onClose}>
                    {translate(`${PREFIX}.CANCEL`)}
                </Button>
                <Button type="primary" disabled={!file || uploading} showSpinner={uploading} onClick={onSubmit}>
                    {translate(`${PREFIX}.SUBMIT`)}
                </Button>
            </div>
        </>
    );
};

UploadView.propTypes = {
    translate: PropTypes.func.isRequired,
    formatRows: PropTypes.arrayOf(PropTypes.object).isRequired,
    helpLink: PropTypes.string,
    file: PropTypes.instanceOf(File),
    uploading: PropTypes.bool.isRequired,
    onFileChange: PropTypes.func.isRequired,
    onClearFile: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default UploadView;
